import { PayoutFormat } from "./payoutFormat";

export class Sidepot {
    id: number;
    name: string;
    cost: number;
    officeFee: number;

    maleAgeFloor: number;
    maleAgeCap: number;
    femaleAgeFloor: number;
    femaleAgeCap: number;
    ageMethod: string = "Day Of";
    maxEntries: number = 32000;
    maxEntriesPerContestant: number = 100;
    uniqueRunsOnly: boolean = true;

    targetOneScheduleId: number;
    targetTwoScheduleId: number;

    maxDivisions: number = 5;
    leaderDivisions: boolean = false;
    divisionOffsets: any;

    sidepotGroupId: number;

    addedMoney: number;
    places: number;
    placesEveryXRuns: number;
    payoutPercentage: number;

    payoutFormat: PayoutFormat;
    payoutMode: string;
    payoutType: string;
}


// WEBPACK FOOTER //
// ./src/model/sidepot.ts